export default __webpack_public_path__ + "static/media/moon-logo.b1e36cc0.png";